<!-- <ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader> -->
<div style="overflow: auto;">
  <div class="claim_main_div_wrapper" *ngIf="claimCondition !== 3">
    <div class="claim_header_div">
      <img src="../../../assets/img/foodbud_icon.svg" alt="logo-img" class="img_logo_foodbud" />
    </div>
    <div class="claim_body_main_div">
      <div class="claim_body_left_side">
        <div class="claim_body_left_side_sub_div">


          <div class="cl_heading">
            <span>
              List Your Restaurant for Free
            </span>
            <br />
            <span class="cl_heading_span_img">
              on Foodbud & Grow with AI
              <img src="../../../assets/img/ai_star.gif" alt="gif">
            </span>

          </div>


          <div class="cl_sub_heading">
            <span>
              Easily claim your restaurant, manage your business, <br />
              and reach more customers with the power of AI-driven insights
            </span>
          </div>


          <div class="cl_search_box_div" (click)="onContainerClick($event)">
            <label for="resto_name">Please Enter your food business name to claim or edit</label>
            <input #searchInput type="text" name="resto_name" id="resto_name_inp" [(ngModel)]="searchText"
              (ngModelChange)="onInputChange($event)" (focus)="showDropdown = true" (keydown)="onKeyDown($event)"
              autocomplete="off" />

            <div class="costum_dropdwon_main_div" *ngIf="showDropdown && filteredDropdwonOptions.length > 0">
              <div class="costum_dropdwon_sub_div">
                <div *ngFor="let option of filteredDropdwonOptions; let i = index" class="drop_option"
                  [class.active]="i === selectedIndex"
                  (click)="selectOption(i == 0 ?{name:searchText, place_id:null} :option)">
                  {{ i == 0 ? searchText : option.name }}
                </div>
              </div>
            </div>
          </div>


          <div class="cl_final_btn_main_div">
            <button class="cl_submit_btn cl_submit_btn_active" (click)="fetchRestaurantDtls()"
              [ngClass]="{'cl_submit_btn_active': this.selectedOption && this.searchText}">View Restaurant
              Detail</button>
          </div>


          <div style="margin-top: 2rem;">
            <div class="cl_sub_heading">The Foodbud Restaurant discovery app is available on both Play store and App
              store.</div>
            <div style="display: flex;justify-content: start; gap:2px;margin-top: 10px;">
              <img src="../../../assets/img/play_store.avif" alt="google-play" style="cursor: pointer;"
                (click)="openStore('https://play.google.com/store/apps/details?id=com.cms.foodbudapp')">
              <img src="../../../assets/img/app_store.avif" alt="app-store" style="cursor: pointer;"
                (click)="openStore('https://apps.apple.com/in/app/foodbud/id1584641741')">
            </div>
          </div>


        </div>
      </div>
      <div>
        <div>
          <img src="../../../assets/img/claim_store_img.svg" alt="store-img">
        </div>
      </div>
    </div>
  </div>


  <div class="preloading_main_div" *ngIf="preloadingFlag">
    <div class="cotum_loader">
      <div class="step1_loader">
        <div>
          <div style="text-align: center;"><img src="../../../assets/img/ai_cratation.gif" alt="" style="height: 84px;">
          </div>

          <div
            style="text-align: center; margin-top: 13px;font-family: 'Inter', sans-serif; font-weight: 600; font-size: 18px; ">
            Generating With AI</div>

          <div>
            <div
              style="text-align: center; font-family: 'Inter', sans-serif; font-weight: 500; font-size: 14px; color: #000000; margin-top: 5rem;">
              Building & claiming your editable business profile…
              <br />
              This should only take 30–40 seconds.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  <div class="email_dialog_box_main_div" *ngIf="claimCondition == 1 || claimCondition == 2">
    <div class="email_dialog_box_sub_div">
      <div class="email_dialog_box" *ngIf="claimCondition == 1">
        <div class="email_dialog_main_heading" *ngIf="!approveedData.isApproved">One last step!</div>
        <ng-container *ngIf="emailToVerify.length > 0; else noEmailTempete">
          <div class="close_main_div"><img src="../../../assets/img/close-svgrepo-com.svg" alt=""
              (click)="claimCondition = 0"></div>
          <div class="email_dialog_box_heading" *ngIf="!changeEmailFlag && !approveedData.isApproved">Based on our
            search, following is the official
            email addresses
            associated
            with your resturant</div>

          <div class="email_dialog_box_heading" style="text-align: center;" *ngIf="!changeEmailFlag && approveedData.isApproved">Verify Your Email to Continue</div>
          <ng-container *ngIf="!changeEmailFlag">
            <div class="email_dialog_box_email_div" *ngFor="let email of emailToVerify;let i=index">
              <input type="radio" [name]="'email'" [id]="'email'+i" [checked]="i==0">
              <label [for]="'email'+i">
                <div>
                  <span>{{email}}</span>
                </div>
              </label>
            </div>
          </ng-container>

          <div class="email_dialog_box_heading" *ngIf="changeEmailFlag">Please enter the email address associated with
            your restaurant</div>
          <div class="email_dialog_box_email_div" style="margin-top: 1.8rem;" *ngIf="changeEmailFlag">
            <input type="email" class="email_otp_inp" [(ngModel)]="enterEmail">
          </div>

          <div>
            <div class="change_email_btn" (click)="changeEmail()" *ngIf="!changeEmailFlag && !approveedData.isApproved">Use different email address
            </div>
          </div>
          <div style="flex: 1;">&nbsp;</div>
          <div class="email_dialog_box_button_div">
            <button [ngClass]="{active_button: selectedEmailToVerify}" *ngIf="!changeEmailFlag"
              (click)="getOtp()">Continue</button>
            <button [ngClass]="{active_button: enterEmail}" *ngIf="changeEmailFlag"
              (click)="getOtp(enterEmail)">Continue</button>
          </div>
        </ng-container>

        <ng-template #noEmailTempete>
          <div class="close_main_div"><img src="../../../assets/img/close-svgrepo-com.svg" alt=""
              (click)="claimCondition = 0"></div>
          <div class="email_dialog_box_heading">Based on our search, we couldn’t find any official Email address
            associated with your restaurant. Please enter your email address.</div>
          <div class="email_dialog_box_email_div" style="margin-top: 1.8rem;">
            <input type="email" class="email_otp_inp" [(ngModel)]="enterEmail">
          </div>
          <div style="flex: 1;">&nbsp;</div>
          <div class="email_dialog_box_button_div">
            <button [ngClass]="{active_button: enterEmail != '' || enterEmail != null}"
              (click)="getOtp(enterEmail)">Continue</button>
          </div>

        </ng-template>


      </div>


      <div class="email_dialog_box" *ngIf="claimCondition == 2">
        <div class="email_dialog_box_heading" style="display: flex; flex-direction: column; flex: 1">
          <div class="email_dialog_box_heading" style="text-align: center; color: #0D0D0D;">
            We have sent an OTP to <span style="color: #2E8198;">{{selectedEmailToVerify}}.</span>
            <br>
            Please enter the OTP to verify.
          </div>

          <div style="text-align: center;margin-top: 3rem;">
            <input type="text" name="otp" class="otp_inp_cl_2" maxlength="4" pattern="\d*" inputmode="numeric"
              [(ngModel)]="enteredOtp">
          </div>

          <div style="margin-top: 1rem;text-align: center;color: black;">Didn’t receive OTP? <span
              style="color:#2E8198; cursor: pointer;" (click)="resendOtp()">Resend OTP</span></div>

          <div style="flex:1">&nbsp;</div>
          <div class="email_dialog_box_button_div">
            <button [ngClass]="{active_button: enteredOtp?.length == 4}" (click)="verifyOtp()">Verify with OTP</button>
          </div>
        </div>
      </div>
    </div>
  </div>



</div>


<div class="email-loader-main-div" *ngIf="emailLoader">
  <span class="email-loader"></span>
</div>









<!-- -------------------------------------------------------- -->
<div *ngIf="claimCondition == 3">
  <div>
    <!-- <app-claim-detail [place_id]="null" [openAiRestoInfo]="null"  [restosName]="'asdfasf'" [restosEmail]="'asdf22@dfsa.dsf'" ></app-claim-detail> -->
    <app-claim-detail [place_id]="selectedOption.place_id" [openAiRestoInfo]="allRestoOpenAIData"
      [restosName]="searchText" [restosEmail]="selectedEmailToVerify" [approvedData]="approveedData"></app-claim-detail>
  </div>
</div>